/**
 * @file 角色管理模块 - 枚举定义
 * @description 定义角色管理相关的所有枚举类型
 * 
 * @module types/role/enums
 * @category Role - 角色管理
 * 
 * @author YSFL Team
 * @created 2025-10-18
 * @last-updated 2025-10-18
 * 
 * ==========================================
 * 文件职责
 * ==========================================
 * 1. 定义数据权限范围枚举（DataScope）
 * 2. 确保枚举值与后端完全一致
 * 3. 为每个枚举值提供清晰的中文说明
 * 
 * ==========================================
 * 对应后端文件
 * ==========================================
 * - Model: backend/app/Models/Role.php
 *   - 常量定义：DATA_SCOPE_* 系列常量
 * 
 * ==========================================
 * 注意事项
 * ==========================================
 * 1. ⚠️ 枚举值必须与后端 Model 常量完全一致（包括大小写）
 * 2. ⚠️ 修改枚举时必须同步更新 constants.ts 中的标签映射
 * 3. ⚠️ 所有枚举值必须有中文注释说明其业务含义
 * 
 * ==========================================
 * 更新时机
 * ==========================================
 * 当以下情况发生时需要更新本文件：
 * - 后端 Role Model 新增数据权限范围常量
 * - 后端修改现有枚举值
 * 
 * ==========================================
 * 验证方式
 * ==========================================
 * 1. 对照 backend/app/Models/Role.php 中的常量定义
 * 2. 确保枚举值类型、个数、命名完全匹配
 * 3. 运行 `npm run type-check` 确保 TypeScript 编译通过
 */

/**
 * 数据权限范围
 * 
 * @description 定义角色的数据访问权限范围
 * @backend Model: Role::DATA_SCOPE_*
 */
export enum DataScope {
  /** 全部数据权限 - 可以访问系统中的所有数据 */
  ALL = 1,
  
  /** 自定义数据权限 - 可以自定义选择哪些部门的数据 */
  CUSTOM = 2,
  
  /** 本部门数据权限 - 只能访问自己所在部门的数据 */
  DEPT = 3,
  
  /** 本部门及以下数据权限 - 可以访问自己部门及其子部门的数据 */
  DEPT_AND_CHILD = 4,
  
  /** 仅本人数据权限 - 只能访问自己的数据 */
  SELF = 5,
}

